export abstract class PushNotificationsRepository {
  abstract createDeviceId(deviceId: string): void;
  abstract createPendingDevice(): void;
}
